import { defaultFont } from "./material-kit-react.js"

import tooltip from "./tooltipsStyle.js";

const C2_VIOLET = "#7628FF";
const C2_VIOLET_SOFT = "#a78bfa";

const headerLinksStyle = theme => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: "2px",
  },
  listItem: {
    float: "none",
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "rgba(215, 207, 235, 0.25)"
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  navLink: {
    color: "inherit",
    position: "relative",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(200, 200, 200, 0.2)"
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px"
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex"
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  icons: {
    width: "18px",
    height: "18px",
    marginRight: "6px"
  },
  socialIcons: {
    position: "relative",
    fontSize: "18px !important",
    marginRight: "0"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px"
    }
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px"
  },
  navLinkActiveHome: {
    color: `${C2_VIOLET} !important`,
    position: "relative",
    padding: "10px 12px 12px",
    fontWeight: "700",
    fontSize: "12px",
    textTransform: "uppercase",
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    letterSpacing: "0.6px",
    lineHeight: "18px",
    textDecoration: "none",
    margin: "0 2px",
    display: "inline-flex",
    alignItems: "center",
    background: "transparent !important",
    boxShadow: "none !important",
    transition: "all 0.2s ease",
    "&::after": {
      content: '""',
      position: 'absolute',
      bottom: '2px',
      left: '10px',
      right: '10px',
      height: '3px',
      backgroundColor: C2_VIOLET,
      borderRadius: '2px',
      boxShadow: `0 0 10px rgba(118, 40, 255, 0.75)`,
    },
    "& svg": {
      color: `${C2_VIOLET} !important`,
      marginRight: "6px",
      fontSize: "18px",
    },
    "& p, & span, & .MuiTypography-root": {
      color: `${C2_VIOLET} !important`,
      fontWeight: "700 !important",
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: "12px !important",
      letterSpacing: "0.6px",
    }
  },
  navLinkModern: {
    color: "#FFFFFF !important",
    position: "relative",
    padding: "10px 12px",
    fontWeight: "500",
    fontSize: "12px",
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    lineHeight: "18px",
    textDecoration: "none",
    margin: "0 2px",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "0",
    background: "transparent !important",
    boxShadow: "none !important",
    transition: "all 0.2s ease",
    "&:hover": {
      color: `${C2_VIOLET_SOFT} !important`,
      background: "transparent !important",
    },
    "&:hover svg": {
      color: `${C2_VIOLET_SOFT} !important`,
    },
    "& svg": {
      color: "#FFFFFF !important",
      marginRight: "6px",
      fontSize: "18px",
    },
    "& p, & span, & .MuiTypography-root": {
      color: "#FFFFFF !important",
      fontWeight: "500 !important",
      fontFamily: "'Outfit', 'Poppins', sans-serif !important",
      fontSize: "12px !important",
      letterSpacing: "0.6px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  navLinkModernLight: {
    color: "#1F2937 !important",
    "&:hover": {
      color: `${C2_VIOLET} !important`,
      background: "transparent !important",
    },
    "&:hover svg": {
      color: `${C2_VIOLET} !important`,
    },
    "& svg": {
      color: "#1F2937 !important",
    },
    "& p, & span, & .MuiTypography-root": {
      color: "#1F2937 !important",
    },
  },
  navLinkActiveHomeLight: {
    "&::after": {
      boxShadow: "none",
    },
  },
  socialItem: {
    marginLeft: "6px",
  },
  socialBtn: {
    minWidth: "auto !important",
    padding: "6px 8px !important",
    color: "#FFFFFF !important",
    background: "transparent !important",
    boxShadow: "none !important",
    "&:hover": {
      color: `${C2_VIOLET_SOFT} !important`,
      background: "transparent !important",
    },
  },
  socialBtnLight: {
    color: "#1F2937 !important",
    "&:hover": {
      color: `${C2_VIOLET} !important`,
    },
  },
  langItem: {
    marginLeft: "10px",
  },
  option: {
    "&:hover,&:focus": {
      background: "rgba(118, 40, 255, 0.28)",
      color: "#FFFFFF"
    },
    display: 'flex',
    height: '38px',
    cursor: 'pointer',
    padding: '0 16px',
    borderRadius: '8px',
    alignItems: 'center',
    color: '#FFFFFF',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '13px',
    transition: 'background 0.2s ease',
  },
  optionLight: {
    color: '#1A0F3B',
    "&:hover,&:focus": {
      background: "rgba(100, 17, 237, 0.12)",
      color: '#6411ED',
    },
  },
  optionUl: {
    zIndex: 3000,
    position: 'absolute',
    right: 0,
    padding: '6px',
    marginTop: '8px',
    borderRadius: '12px',
    background: 'rgba(26, 15, 59, 0.98)',
    backdropFilter: 'blur(16px)',
    border: `1px solid rgba(118, 40, 255, 0.45)`,
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.55)',
    minWidth: '130px',
    listStyle: 'none',
  },
  optionUlLight: {
    background: '#FBFAFE',
    border: '1px solid #D7CFEB',
    boxShadow: '0 8px 20px rgba(26, 15, 59, 0.12)',
  },
  toggleDropdown: {
    display: 'flex',
    height: '34px',
    background: 'rgba(15, 7, 28, 0.45)',
    backdropFilter: 'blur(10px)',
    padding: '4px 14px',
    fontSize: '13px',
    fontWeight: '500',
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    borderRadius: '10px',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    border: `1.5px solid ${C2_VIOLET}`,
    color: '#FFFFFF',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: C2_VIOLET_SOFT,
      boxShadow: '0 0 12px rgba(118, 40, 255, 0.35)',
    }
  },
  listMobile: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "4px",
    "& > li": {
      width: "100%",
      margin: 0,
      "&:after": { display: "none" },
    },
  },
  navLinkMobile: {
    width: "100% !important",
    margin: "0 !important",
    padding: "13px 16px !important",
    borderRadius: "12px !important",
    justifyContent: "flex-start !important",
    "&::after": { display: "none" },
    "& svg": { fontSize: "20px", width: "20px", height: "20px", marginRight: "12px" },
    "& p, & span, & .MuiTypography-root": {
      fontSize: "14px !important",
      letterSpacing: "0.8px",
    },
    "&:hover": {
      background: "rgba(118, 40, 255, 0.18) !important",
    },
  },
  navLinkMobileActive: {
    background: `linear-gradient(90deg, #6411ED 0%, ${C2_VIOLET} 100%) !important`,
    boxShadow: "0 6px 16px rgba(100, 17, 237, 0.35) !important",
    "& svg, & p, & span, & .MuiTypography-root": {
      color: "#FFFFFF !important",
    },
  },
  socialRowMobile: {
    display: "flex !important",
    gap: "8px",
    padding: "14px 4px 4px !important",
    marginTop: "10px !important",
    borderTop: "1px solid rgba(215, 207, 235, 0.14)",
  },
  socialBtnMobile: {
    width: "44px",
    height: "44px",
    borderRadius: "12px !important",
    border: "1px solid rgba(215, 207, 235, 0.22) !important",
    backgroundColor: "rgba(251, 250, 254, 0.06) !important",
  },
  langItemMobile: {
    padding: "8px 4px 0 !important",
    "& > div": { justifyContent: "flex-start !important" },
  },
  toggleDropdownLight: {
    background: '#FFFFFF',
    color: '#1A0F3B',
    border: `1.5px solid ${C2_VIOLET}`,
    '&:hover': {
      borderColor: '#6411ED',
      boxShadow: '0 0 10px rgba(100, 17, 237, 0.2)',
    }
  }
});

export default headerLinksStyle;
